import type { RtcConnection } from 'features/sip/interfaces';

export const getNetworkStats = async (rtcConnection: RtcConnection | null) => {
  const stats = await rtcConnection?.getStats();

  if (!stats) {
    return {
      error: 'rtc disconnected',
    };
  }

  const network_stats = stats.values()
    ? [...stats.values()].reduce(
        (stat, report) => {
          if (report.type === 'outbound-rtp' && report.kind === 'video') {
            return {
              ...stat,
              outgoing: {
                bytes: report.bytesSent,
                fps: report.framesPerSecond,
                timestamp: report.lastPacketReceivedTimestamp,
              },
            };
          } else if (report.type === 'inbound-rtp' && report.kind === 'video') {
            return {
              ...stat,
              incoming: {
                bytes: report.bytesReceived,
                fps: report.framesPerSecond,
                timestamp: report.lastPacketReceivedTimestamp,
              },
            };
          }
          return stat;
        },
        {
          incoming: { bytes: 0, fps: 0, timestamp: 0 },
          outgoing: { bytes: 0, fps: 0, timestamp: 0 },
        }
      )
    : {
        error: "can't fetch network info from rtc",
      };

  return network_stats;
};
